import React, { useContext, useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import InfiniteScroll from 'react-infinite-scroll-component'
import { MigrantContext } from '../../../contexts/migrantContext'
import { CreditHistory } from '../../../models/Credit'
import Layout from '../../common/layout/layout'
import CreditHistoryItem from './creditHistoryItem'
import styles from './index.module.css'

const ITEMS_PER_PAGE = 10

const Wallet = () => {
  const context = useContext(MigrantContext)
  const credits = context?.credits
  const avatarUrl = context?.profile?.avatarUrl ?? 'profilepic.png'
  const [hasMoreData, setHasMoreData] = useState(false)
  const [historyItems, setHistoryItems] = useState<CreditHistory[]>([])
  const [allHistoryItems, setAllHistoryItems] = useState<CreditHistory[]>([])

  useEffect(() => {
    const history = credits?.history ?? []
    const sortedHistory = [...history].sort(
      (a, b) => b.date.getTime() - a.date.getTime()
    )
    setAllHistoryItems(sortedHistory)

    if (historyItems.length === 0) {
      setHistoryItems([...sortedHistory.slice(0, ITEMS_PER_PAGE)])
      setHasMoreData(sortedHistory.length > ITEMS_PER_PAGE)
    } else {
      setHistoryItems([...sortedHistory.slice(0, historyItems.length)])
      setHasMoreData(sortedHistory.length > historyItems.length)
    }
  }, [context?.credits]) // eslint-disable-line

  const fetchMoreData = () => {
    if (allHistoryItems.length <= historyItems.length) {
      setHasMoreData(false)
      return
    }

    setHasMoreData(true)
    setHistoryItems([
      ...allHistoryItems.slice(0, historyItems.length + ITEMS_PER_PAGE)
    ])
  }

  return (
    <Layout>
      <Row>
        <Col xl={8} className="mx-auto">
          <Row>
            <Col>
              <h1 className="pageTitle">Your Wallet</h1>
            </Col>
          </Row>

          <Row className={`${styles.balanceBlock} mb-5`}>
            <Col>
              <div>
                <b data-testid="currentBalance">
                  {(credits?.currentBalance ?? 0).toLocaleString()}
                </b>{' '}
                BMC
              </div>
            </Col>
          </Row>

          <Row>
            <Col className="pb-2">
              <h1 className="pageTitle">Credits History</h1>
            </Col>
          </Row>

          {historyItems.length === 0 ? (
            <Row>
              <Col>
                <p
                  data-testid="noTransactions"
                  className="text-center text-dark"
                >
                  No transactions yet
                </p>
              </Col>
            </Row>
          ) : (
            <InfiniteScroll
              dataLength={historyItems.length}
              next={fetchMoreData}
              hasMore={hasMoreData}
              loader={<p className="text-center">Loading...</p>}
            >
              {historyItems.map((history, i) => {
                return (
                  <CreditHistoryItem
                    history={history}
                    key={`historyItem-${i}`}
                    avatarUrl={avatarUrl}
                  />
                )
              })}
            </InfiniteScroll>
          )}
        </Col>
      </Row>
    </Layout>
  )
}

export default Wallet
